// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__C3YBj","dragIcon":"Choice_dragIcon__2Uyhq","left":"Choice_left__1rYbK","input":"Choice_input__3BGsI"};